import { AbstractProjectDataTableReport } from '@vertical-plus/vue-js-micro-service-components/lib/model/service/report/abstract-project-data-table-report';
import { v4 as uuidv4 } from 'uuid';
import Project from '@vertical-plus/vue-js-micro-service-components/lib/model/entity/organisation/project';
import ServiceContainer from '../service-container';

export abstract class AbstractVpaDataTableReport extends AbstractProjectDataTableReport
{
    public id = uuidv4();
    protected serviceContainer: ServiceContainer;

    public constructor(serviceContainer: ServiceContainer)
    {
        super(serviceContainer, new Project({
            id: '4209cb2c-27ae-4701-a6c1-258cce6f5d18',
            title: 'Vertical Plus',
            apiKey: null,
            description: null,
            tags: [],
            members: 0,
            projectUsers: [],
            teams: [],
            user: null,
            dateCreated: '2022-11-15 17:30',
            dateUpdated: '2022-11-15 17:30',
        }));

        this.serviceContainer = serviceContainer;
    }
}